import './phone-qualification-workspace.ajscss';

import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IAppointment } from '@commons/models/appointment';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { copy, IComponentController, IComponentOptions, isDefined } from 'angular';
import moment from 'moment';
import { map, take } from 'rxjs';

import {
  Booking,
  Campaign,
  CampaignType,
  ChannelDirection,
  ChannelType,
  deepCopy,
  FormFacade,
  MomentService,
  None,
  Option,
  QualificationFacade,
  QualificationFieldData,
  QualificationService,
  Reschedule,
  RescheduleReason,
  RescheduleTarget,
  TimeSlot,
  TimeSlotSelect,
  unmarshal,
  Writable,
} from '@contact/upgrade';

import templateUrl from './phone-qualification-workspace.template.html';

const MODULE_NAME = 'contactPhoneQualificationWorkspace';
const DEFAULT_RESCHEDULE: Reschedule = {
  reason: RescheduleReason.PROCESSED,
  time: 0,
  date: new Date().getTime(),
  description: '',
  target: RescheduleTarget.INDIFFERENT,
};

class PhoneQualificationWorkspaceCtrl implements IComponentController {
  public name = MODULE_NAME;
  RescheduleReason = RescheduleReason;
  RescheduleTarget = RescheduleTarget;

  responseId: string;
  canFinishQualification: boolean = false;

  // TODO refactor all campaign reschedule mechanism
  campaign: Campaign | undefined;
  appointment: IAppointment;
  reschedule = copy(DEFAULT_RESCHEDULE);
  rescheduleReasonKey: string;
  canBeRescheduled: boolean = false;
  canBeReassigned: boolean = false;
  isCampaignContact: boolean = false;
  isAppointmentCampaign: boolean = false;
  haveQualifaction: boolean = false;
  selectedDayTimeSlot: Writable<TimeSlotSelect>;
  selectedTimeSlot: Writable<TimeSlot>;
  textMessage: string | undefined;
  availablerescheduleTimes: number[] = [];
  availableDayTimeSlots: Writable<TimeSlotSelect>[] = [];
  campaignEndDate: Date | undefined;
  today: Date = new Date();
  rescheduleDateForSimpleCampaign: Date;
  selectedTime: number;
  private timeout;

  constructor(
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly momentService: MomentService,
    private readonly qualificationFacade: QualificationFacade,
    private readonly formFacade: FormFacade
  ) {}

  $onInit(): void {
    this.qualificationFacade
      .getById(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(qualification => {
        this.canFinishQualification = !!qualification && qualification.canInterrupt;
        this.haveQualifaction = !!qualification && (qualification.fields.length > 0 || qualification.ratingQualityEnabled);
      });
    // TODO refactor all campaign reschedule mechanism
    this.contactDeprecatedService.getContact(this.responseId).then(contact => {
      this.contactDeprecatedService.getCustomer(this.responseId).then(customer => {
        this.campaign = contact.campaign?.campaign;
        this.canBeRescheduled = contact.campaign?.canBeRescheduled ?? false;
        this.canBeReassigned = contact.campaign?.canBeReassigned ?? false;
        this.isCampaignContact =
          Option.of(contact.campaign)
            .map(campaign => campaign.campaign.id)
            .getOrElse('') !== '' &&
          contact.channel.direction === ChannelDirection.OUTGOING &&
          contact.channel.type === ChannelType.PHONE;

        this.textMessage = contact.campaign?.contactCampaignTextMessage;
        if (this.isCampaignContact) {
          if (this.canBeRescheduled && contact.campaign) {
            this.campaignEndDate = contact.campaign.campaign?.endDate ? new Date(contact.campaign.campaign?.endDate) : undefined;
            if (contact.campaign.campaign?.type === CampaignType.SCHEDULED_CALL_BACK) {
              this.isAppointmentCampaign = true;
              this.appointmentDeprecatedService.buildEmptyAppointment().then(appointment => {
                this.appointment = appointment;
                // buildAppointment creates a new UUID for a new Booking
                // => Put the id of the existing contact into it.
                this.appointment.idContact = contact.campaign?.campaignContactId || '';
                this.appointment.campaign = contact.campaign?.campaign!;
                this.appointment.phone = contact.phoneNumber || '';
                this.appointment.firstName = Option.of(customer)
                  .map(({ firstname }) => firstname)
                  .getOrElse('');
                this.appointment.lastName = Option.of(customer)
                  .map(({ lastname }) => lastname)
                  .getOrElse('');
                this.appointmentDeprecatedService.getSkills().then(skills => {
                  this.appointment.skillList = skills.filter(skill => contact.skills.indexOf(skill.id) >= 0);
                });
                this.appointmentDeprecatedService
                  .getOpenedTimeSlots(contact.campaign?.campaign?.id!, this.campaignEndDate)
                  .then(timeSlots => {
                    this.initializeOpenedTimeSlots(timeSlots);
                    this.buildAndSetReschedule(contact);
                  });
              });
            } else {
              let dateToUse = contact.reschedule ? contact.reschedule.date : this.reschedule.date;
              this.appointmentDeprecatedService
                .retrieveRescheduleTimesForDay(contact.campaign.campaign.id, new Date(dateToUse))
                .then(availablerescheduleTimes => {
                  this.availablerescheduleTimes = availablerescheduleTimes;
                })
                .then(() => {
                  this.buildAndSetReschedule(contact);
                });
            }
          } else {
            this.buildAndSetReschedule(contact);
          }
          this.rescheduleDateForSimpleCampaign = new Date(this.reschedule.date);
        }
      });
    });
  }

  readableTimeSlotSelect(timeSlot: TimeSlot) {
    return `${this.momentService.readableTime(timeSlot.beginDate)} -> ${this.momentService.readableTime(timeSlot.endDate)} - ${
      timeSlot.contactCount
    }/${timeSlot.contactThreshold}`;
  }

  timeParts(timeInSeconds: number): [number, number, number] {
    // tslint:disable
    let hours = (timeInSeconds / 3600) >> 0;
    let hoursRest = timeInSeconds % 3600;
    let min = (hoursRest / 60) >> 0;
    let seconds = hoursRest % 60 >> 0;
    // tslint:enable
    return [hours, min, seconds];
  }

  getReadableTime(time: number): string {
    let timeParts: Array<number> = this.timeParts(time / 1000);
    return this.momentService.readableTime(new Date(0, 0, 0, timeParts[0], timeParts[1], timeParts[2]));
  }

  valueRescheduleDateChanged() {
    // keep agent timezone and send timestamp to campaign server
    let date = new Date(this.rescheduleDateForSimpleCampaign);
    let hours = new Date(this.selectedTime);
    date.setHours(hours.getUTCHours());
    date.setMinutes(hours.getUTCMinutes());
    date.setSeconds(0);
    date.setMilliseconds(0);
    const newReschedule: Reschedule = {
      ...this.reschedule,
      date: this.momentService.getMoment(date).toDate().getTime(),
    };
    this.reschedule = newReschedule;
    if (this.canBeRescheduled && this.isCampaignContact && this.campaign) {
      // update reschedule field in bookign store
      this.contactDeprecatedService
        .updateReschedule(this.responseId, this.reschedule, Option.of(this.selectedDayTimeSlot), Option.of(this.selectedTimeSlot))
        .then(() => {
          if (this.campaign) {
            this.appointmentDeprecatedService
              .retrieveRescheduleTimesForDay(this.campaign.id, this.rescheduleDateForSimpleCampaign)
              .then(availablerescheduleTimes => (this.availablerescheduleTimes = availablerescheduleTimes))
              .then(() => {
                if (this.availablerescheduleTimes.length > 0) {
                  this.reschedule = {
                    ...this.reschedule,
                    time: this.availablerescheduleTimes[0],
                  };
                }
              });
          }

          this.formFacade
            .getData(QualificationService.toFormId(this.responseId))
            .pipe(
              take(1),
              map(data => unmarshal<QualificationFieldData[]>(data == undefined ? [] : data['FIELDS'])),
              map(data => (data == undefined ? [] : data))
            )
            .subscribe(data => this.qualificationFacade.saveOnClosed(this.responseId, data));
        });
    }
  }

  valueChanged() {
    Option.of(this.timeout).forEach(t => clearTimeout(t));
    this.timeout = setTimeout(() => {
      let timeSlotToSave = isDefined(this.appointment) && this.appointment ? Option.of(this.appointment.timeSlot) : None;
      this.contactDeprecatedService.updateReschedule(this.responseId, this.reschedule, Option.of(this.selectedDayTimeSlot), timeSlotToSave);
      this.timeout = null;

      this.formFacade
        .getData(QualificationService.toFormId(this.responseId))
        .pipe(
          take(1),
          map(data => unmarshal<QualificationFieldData[]>(data == undefined ? [] : data['FIELDS'])),
          map(data => (data == undefined ? [] : data))
        )
        .subscribe(data => this.qualificationFacade.saveOnClosed(this.responseId, data));
    }, 500);
  }

  onTimeSlotChange() {
    let timeSlotToSave = isDefined(this.appointment) && this.appointment ? Option.of(this.appointment.timeSlot) : None;
    this.contactDeprecatedService
      .updateReschedule(this.responseId, this.reschedule, Option.of(this.selectedDayTimeSlot), timeSlotToSave)
      .then(() => {
        if (
          this.isAppointmentCampaign &&
          this.reschedule.reason === RescheduleReason.TORECALL &&
          !!this.appointment &&
          this.appointment.timeSlot
        ) {
          this.appointmentDeprecatedService.changeAppointment(this.appointment);
        } else if (!!this.appointment && !this.appointment.timeSlot && !!this.selectedDayTimeSlot) {
          if (!!this.selectedDayTimeSlot.timeSlots && this.selectedDayTimeSlot.timeSlots.length > 0) {
            this.appointment.timeSlot = this.selectedDayTimeSlot.timeSlots[0];
          }
          this.onTimeSlotChange();
        }
      });
  }

  private initializeOpenedTimeSlots(timeSlots: TimeSlot[]): void {
    let localMap = {};
    this.availableDayTimeSlots = [];
    timeSlots.forEach(timeSlot => {
      let daySt = moment(timeSlot.beginDate).format('YYYY_MM_DD');
      let mapEntry: TimeSlotSelect;
      if (!localMap.hasOwnProperty(daySt)) {
        mapEntry = {
          daySt: this.momentService.getMoment(timeSlot.beginDate).format('DD MMMM YYYY'),
          timeSlots: [],
          weekNumber: 0,
        };
        this.availableDayTimeSlots.push(mapEntry);
        localMap[daySt] = mapEntry;
      } else {
        mapEntry = localMap[daySt];
      }
      if (isDefined(mapEntry)) {
        mapEntry.timeSlots.push(timeSlot);
      }
    });
  }

  private buildAndSetReschedule(contact: Booking): void {
    if (!contact.reschedule) {
      // copy default reschedule
      this.reschedule = deepCopy(DEFAULT_RESCHEDULE);
      // set first available time slot if available
      if (this.canBeRescheduled && this.availablerescheduleTimes.length > 0) {
        this.reschedule = {
          ...this.reschedule,
          time: this.availablerescheduleTimes[0],
        };
      }
      if (!this.canBeReassigned) {
        this.reschedule = {
          ...this.reschedule,
          target: RescheduleTarget.SELF,
        };
      }

      if (this.selectedDayTimeSlot) {
        if (this.selectedDayTimeSlot.timeSlots && this.selectedDayTimeSlot.timeSlots.length > 0 && this.appointment) {
          this.appointment.timeSlot = this.selectedDayTimeSlot.timeSlots[0];
        }
        this.onTimeSlotChange();
      } else {
        const availableTimeSlot = this.availableDayTimeSlots.filter(dayTimeslot =>
          dayTimeslot.timeSlots ? dayTimeslot.timeSlots.filter(timeSlot => timeSlot.contactCount < timeSlot.contactThreshold) : false
        );
        const potentialDayTimeslot = availableTimeSlot.length > 0 ? availableTimeSlot[0] : null;
        if (potentialDayTimeslot) {
          this.selectedDayTimeSlot = potentialDayTimeslot;
          const availableSlot = potentialDayTimeslot.timeSlots.filter(timeSlot => timeSlot.contactCount < timeSlot.contactThreshold);
          if (availableSlot.length > 0 && !!this.appointment) {
            this.appointment.timeSlot = availableSlot[0];
          }
          this.onTimeSlotChange();
        }
      }
    } else {
      // restore previously selected time slot
      this.reschedule = deepCopy(contact.reschedule);
      // load the selected time and date to corresponding fields => always show if selected
      if (this.isAppointmentCampaign) {
        const potentialDayTimeslot = this.availableDayTimeSlots.find(
          dayTimeslot => contact.selectedDayTimeSlot && dayTimeslot.daySt === contact.selectedDayTimeSlot.daySt
        );
        if (potentialDayTimeslot) {
          this.selectedDayTimeSlot = potentialDayTimeslot;
        }
        if (!!this.selectedDayTimeSlot && this.selectedDayTimeSlot.timeSlots && contact.selectedTimeSlot) {
          const appointmentTimeSlot = this.selectedDayTimeSlot.timeSlots.find(
            timeSlot => contact.selectedTimeSlot && timeSlot.id === contact.selectedTimeSlot.id
          );
          if (appointmentTimeSlot && this.appointment) {
            this.appointment.timeSlot = appointmentTimeSlot;
          }
        }
        if (this.selectedDayTimeSlot) {
          this.onTimeSlotChange();
        }
      }
    }
  }
}

export class PhoneQualificationWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    'contactDeprecatedService',
    'appointmentDeprecatedService',
    'momentService',
    'qualificationFacade',
    'formFacade',
    PhoneQualificationWorkspaceCtrl,
  ];
}

export default MODULE_NAME;
